import {TextColor} from '@priority-software/priority-style-react';

export enum ContextMenuTextColor {
    black = 'primary-700',
    red = 'red'
}

export type ContextArrayType = {
    name: string;
    shortCode?: string;
    onClick: () => void;
    subMenu?: ContextArrayType;
    color?: TextColor;
    divider?: boolean;
    hidden?: boolean;
    planning?: boolean;
}[];
